import type { ErrorDetails } from "../components/error-alert";

/**
 * Extracts the common url/statusCode/response fields from an unknown caught
 * value (either a thrown ResponseError or a raw Error). Callers should spread
 * the result and add any context-specific fields (e.g. consumerId, dealerId).
 *
 * @example
 * setErrorDetails({ ...extractErrorDetails(err), consumerId: customerId });
 */
export function extractErrorDetails(
  error: unknown
): Pick<ErrorDetails, "url" | "statusCode" | "response"> {
  const typed = error as {
    url?: string;
    statusCode?: number;
    errorResult?: unknown;
  };
  return {
    url: typed?.url,
    statusCode: typed?.statusCode,
    response:
      typed?.errorResult instanceof Error
        ? typed.errorResult.message
        : (typed?.errorResult as string) ?? undefined
  };
}
